import {combineReducers} from 'redux'
import imageItems from './reducer'

export default combineReducers({
    imageItems,
})
